module.exports = __webpack_public_path__ + "img/empty-map.44db978a.svg";